import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import validationRules from 'coreUtils/validationRules';

import Field from 'brandComponents/Form/Subcomponents/Field';
import Typography from 'brandComponents/Typography';
import {useURLs} from 'brandHooks';

import {ISelectPaymentMethod} from './ISelectPaymentMethod';
import messages from './messages';

import styles from './SelectPaymentMethod.module.scss';

const SelectPaymentMethod = ({paymentInstruments, values}: ISelectPaymentMethod) => {
	const intl = useIntl();
	const urls = useURLs();

	if (!paymentInstruments.some((i) => i.id === 'CASH_ON_DELIVERY')) {
		return;
	}

	const isIban = (selectedRefundMethod: string) => selectedRefundMethod === 'CASH_ON_DELIVERY';

	return (
		<>
			<Typography classNames={styles['return-create-payment__description']} variant="p">
				{intl.formatMessage(messages.description)}
			</Typography>
			{paymentInstruments.map((instrument, i, arr) => (
				<div
					key={instrument.id}
					className={cn(styles['return-create-payment__checkbox-wrapper'], {
						[styles['return-create-payment__checkbox-wrapper--last']]: arr.length === i++,
					})}
				>
					<Field
						name="refundMethod"
						type="radio"
						initialValue={paymentInstruments[0].id}
						value={instrument.id}
						id={instrument.id}
						classNamesCntr={styles['return-create-payment__checkbox']}
					/>
					<label htmlFor={instrument.id}>{instrument.label}</label>
				</div>
			))}
			<Typography classNames={styles['return-create-payment__info']} variant="p">
				{intl.formatMessage(messages.returnRefundsInformation, {
					cta: (chunk) => (
						<a
							href={urls.CUSTOMER_SERVICE_RETURN}
							className={styles['return-create-payment__info-link']}
							target="_blank"
							rel="noreferrer"
						>
							{chunk}
						</a>
					),
				})}
			</Typography>

			{isIban(values?.refundMethod) && (
				<div className={styles['return-create-payment__iban']}>
					<Field
						name="bankAccountHolder"
						type="text"
						component="input"
						placeholder={intl.formatMessage(messages.bankAccountHolderLabel)}
						validation={[
							{
								rule: validationRules.isNotEmpty,
								errorMessage: intl.formatMessage(messages.bankAccountHolderRequiredError),
							},
						]}
					/>
					<Field
						name="phoneNumber"
						type="text"
						component="input"
						placeholder={intl.formatMessage(messages.phoneNumberLabel)}
						validation={[
							{
								rule: validationRules.isNotEmpty,
								errorMessage: intl.formatMessage(messages.phoneNumberRequiredError),
							},
						]}
					/>
					<Field
						name="beneficiaryBank"
						type="text"
						component="input"
						placeholder={intl.formatMessage(messages.beneficiaryBankLabel)}
						validation={[
							{
								rule: validationRules.isNotEmpty,
								errorMessage: intl.formatMessage(messages.beneficiaryBankRequiredError),
							},
						]}
					/>
					<Field
						name="BICSWIFTCode"
						type="text"
						component="input"
						placeholder={intl.formatMessage(messages.BICSWIFTCodeLabel)}
						validation={[
							{
								rule: validationRules.isNotEmpty,
								errorMessage: intl.formatMessage(messages.BICSWIFTCodeRequiredError),
							},
						]}
					/>
					<Field
						name="IBAN"
						type="text"
						component="input"
						placeholder={intl.formatMessage(messages.ibanLabel)}
						validation={[
							{
								rule: validationRules.isNotEmpty,
								errorMessage: intl.formatMessage(messages.ibanRequiredError),
							},
						]}
					/>
				</div>
			)}
		</>
	);
};
export default SelectPaymentMethod;
